import React, { useEffect, useState } from 'react'
import { apiUrl } from '../../../config/api'
import { customSwal } from '../../../config/swal'
import { CarouselItem, ImageCarouselCard } from './components/ImageCarouselCard'

export const ImageCarouselPage = () => {
  const [imagesState, setImagesState] = useState<CarouselItem[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const patchBannerConfig = async () => {
      try {
        const response = await apiUrl.patch(
          '/configuration/banner',
          { banner: '{}', readonly: true },
          { headers: { 'x-api-key': process.env.REACT_APP_PUBLIC_API_KEY } }
        )
        setIsLoading(false)
        setImagesState(response.data.data.banner || [])
      } catch (error: any) {
        customSwal.fire({
          icon: 'error',
          title: 'Error al cargar las imágenes del carrusel',
          text: error.response?.data?.message || 'Ocurrió un error inesperado.',
        })
      }
    }

    patchBannerConfig()
  }, [])

  return <ImageCarouselCard images={imagesState} onSave={setImagesState} isLoading={isLoading} />
}
